module.exports = __webpack_public_path__ + "static/media/lpf_example.66d33fd0.csv";